import { useState } from "react";
import { ContractDateCard } from "../component/ContractDateCard";
import { ContractDepositCard } from "../component/ContractDepositCard";
import { PageHeader } from "../component/PageHeader";

export const Setting = () => {
  const [refreshFlag50, setRefreshFlag50] = useState<boolean>(false);
  const [refreshFlag30, setRefreshFlag30] = useState<boolean>(false);
  const [refreshFlag20, setRefreshFlag20] = useState<boolean>(false);

  return (
    <>
      <PageHeader title="Settings" />
      <div className="grid grid-cols-12 gap-x-5">
        <ContractDateCard />
      </div>

      <div className="grid grid-cols-12 gap-x-5">
        <div className="col-span-12 md:col-span-12 xxl:col-span-12">
          <div className="box ">
            <div className="box-header">
              <div className="sm:flex justify-between space-y-2 sm:space-y-0">
                <h5 className="box-title my-auto">Staking Contract</h5>
                <div className="block ltr:ml-auto rtl:mr-auto my-auto">
                  <h5 className="box-title my-auto">APY: 50</h5>
                </div>
              </div>
            </div>
            <div className="box-body">
              <div className="grid grid-cols-12 gap-x-5">
                <ContractDepositCard
                  apy={50}
                  refreshFlag={refreshFlag50}
                  handleRefreshFlag={setRefreshFlag50}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-12 gap-x-5">
        <div className="col-span-12 md:col-span-12 xxl:col-span-12">
          <div className="box ">
            <div className="box-header">
              <div className="sm:flex justify-between space-y-2 sm:space-y-0">
                <h5 className="box-title my-auto">Staking Contract</h5>
                <div className="block ltr:ml-auto rtl:mr-auto my-auto">
                  <h5 className="box-title my-auto">APY: 30</h5>
                </div>
              </div>
            </div>
            <div className="box-body">
              <div className="grid grid-cols-12 gap-x-5">
                <ContractDepositCard
                  apy={30}
                  refreshFlag={refreshFlag30}
                  handleRefreshFlag={setRefreshFlag30}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-12 gap-x-5">
        <div className="col-span-12 md:col-span-12 xxl:col-span-12">
          <div className="box ">
            <div className="box-header">
              <div className="sm:flex justify-between space-y-2 sm:space-y-0">
                <h5 className="box-title my-auto">Staking Contract</h5>
                <div className="block ltr:ml-auto rtl:mr-auto my-auto">
                  <h5 className="box-title my-auto">APY: 20</h5>
                </div>
              </div>
            </div>
            <div className="box-body">
              <div className="grid grid-cols-12 gap-x-5">
                <ContractDepositCard
                  apy={20}
                  refreshFlag={refreshFlag20}
                  handleRefreshFlag={setRefreshFlag20}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
